import React from "react";
import { TaskExecution } from "../TaskExecution/TaskExecutionListItem";
import { graphql, useFragment } from "react-relay";
import { RoutineOccasionScreenListItemComponent_TaskExecution$key } from "./__generated__/RoutineOccasionScreenListItemComponent_TaskExecution.graphql";
import { useEvent } from "../../../common/useEvent";
import { NavProp } from "./RoutineOccasionScreen";

export const RoutineOccasionScreenListItem = ({
  navigation,
  isArchived,
  taskExecution: te,
  createIssue,
  readOnly,
}: {
  navigation: NavProp;
  taskExecution: RoutineOccasionScreenListItemComponent_TaskExecution$key;
  isArchived: boolean;
  createIssue: (taskExecutionId: string, taskTitle: string) => void;
  readOnly?: boolean;
}) => {
  const taskExecution = useFragment(
    graphql`
      fragment RoutineOccasionScreenListItemComponent_TaskExecution on TaskExecution {
        id
        sectionId
        task {
          id
          instructions
        }
        ...TaskExecutionListItemComponent_taskExecution
      }
    `,
    te
  );

  const openInstructions = useEvent(() => {
    navigation.navigateDeprecated("TaskExecutionInstructionsStack", {
      screen: "TaskExecutionInstructions",
      params: {
        taskId: taskExecution.task.id,
      },
    });
  });

  return (
    <TaskExecution
      taskExecution={taskExecution}
      openInstructions={openInstructions}
      createIssue={createIssue}
      disabled={readOnly || isArchived}
    />
  );
};
